/**
 * Demo-build stub for `@hellopearl/cl-api-configuration` (see
 * `demo/vite.config.ts` aliases). The demo boots already connected with
 * toolbar-controlled feature flags, so the configuration API is never a
 * useful call here; the simulated-login path that reaches
 * `fetchFeatureFlags` already tolerates an empty office list.
 */

export interface OfficeConfig {
  sod_status?: string;
  pi_status?: string;
  insurance_status?: string;
  voice_status?: string;
  [key: string]: unknown;
}

export const CONFIG_SELECT_FIELDS: readonly string[] = [
  'sod_status',
  'pi_status',
  'insurance_status',
  'voice_status',
];

export function initConfigurationApi(..._args: unknown[]): void {}

export async function getAllConfigParams(
  ..._args: unknown[]
): Promise<{ data: OfficeConfig[] }> {
  return { data: [] };
}
